module.exports = __webpack_public_path__ + "img/Group 2896.f4a0bee2.svg";